import { useEffect, useState, useContext, useRef } from 'react'
import { useTheme } from '@mui/material/styles'
import { Stack, Box, Typography, Button } from '@mui/material'
import { motion, useScroll, useMotionValueEvent } from 'framer-motion'
import useMediaQuery from '@mui/material/useMediaQuery'

import { Logo } from '../../components/logo'
import { Icons } from './icons'
import { Link } from 'react-router-dom'

import apple from '../../../assets/apple.svg'
import google from '../../../assets/google.svg'

export const Hero = () => {
  const { scrollY } = useScroll()
  const theme = useTheme()
  // const [scroll, setScroll] = useState(0)

  // useMotionValueEvent(scrollY, 'change', (latest) => {
  //   setScroll(latest)
  // })

  return (
    <>
      <Stack direction='column' spacing={8} justifyContent='flex-start'>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.2, ease: 'easeIn' }}
        >
          <Stack direction='row' alignItems='center' sx={{ maxWidth: '100%' }}>
            <Typography variant='h1' style={{ color: theme.palette.logo[0] }}>
              JoinU
            </Typography>
          </Stack>
        </motion.div>
        <h3 className='text-1xl font-normal tracking-tighter sm:text-2xl'>
        <p>&nbsp;</p>Welcome to JoinU for the Harvard community!
        </h3>
        <h1 className='text-3xl font-bold tracking-tighter sm:text-5xl'>
          Build, Explore, and Connect to the Harvard Community.
        </h1>
        <h3 className='text-1xl font-normal tracking-tighter sm:text-4xl'>
        Join Others, Find U!
        </h3>
        <div>
          <div className='flex flex-col gap-6 min-[400px]:flex-row flex-start bg-red px-6'>
            <Link to='https://app.joinu.org'>
              <Button variant='contained' size='large'>
                Login
              </Button>
            </Link>
          </div>
          <div className='flex flex-col gap-6 min-[400px]:flex-row flex-start bg-red p-6'>
            <Link to='https://apps.apple.com/us/app/joinu-harvard/id6459098232'>
              <img
                alt='apple store link'
                className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
                width='140'
                src={apple}
              />
            </Link>
            <Link to='https://play.google.com/store/apps/details?id=com.elijamunn.joinuharvard&hl=en_US'>
              <img
                alt='apple store link'
                className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
                width='140'
                src={google}
              />
            </Link>
          </div>
        </div>
      </Stack>
    </>
  )
}
